// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1E9Zp","vLegacy":"SelectSecondary_vLegacy__2uMg7","error":"SelectSecondary_error__1gT9j","disabled":"SelectSecondary_disabled__1MMfM"};